var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContextBtn',{attrs:{"name":"selection-count","title":_vm.$t('canvas.context.connectNumber')},on:{"click":_vm.action}},[_c('div',{staticClass:"icon"},[_vm._v(_vm._s(_vm.selectionCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }